// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/styles/admin.scss
// module id = 4
// module chunks = 0